const version = "2.64";

export default version;
